
import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import TrackingSimulator from '../../components/TrackingSimulator/TrackingSimulator';

const defaultTheme = createTheme();

const TackingSimulatorMange=()=>{
     return (
        <ThemeProvider theme={defaultTheme}>
         <TrackingSimulator/>
        </ThemeProvider>
      );
}

export default TackingSimulatorMange